import { Card, CardContent } from '@shared/ui';
import { formatNumber } from '@shared/lib/format';
import type { TimeseriesPoint } from '@entities/stats';
import { Sparkline } from './sparkline';

export function KpiCard({
  label,
  value,
  points,
}: {
  label: string;
  value: number | undefined;
  points?: TimeseriesPoint[];
}) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="text-xs uppercase tracking-wide text-muted-foreground">{label}</div>
        <div className="mt-2 text-3xl font-semibold">{formatNumber(value ?? 0)}</div>
        {points ? (
          <div className="mt-3">
            <Sparkline points={points} />
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
